
import {
  UPDATE_USER_DATA,
  UPDATE_ETE_SIGNATURE,
  UPDATE_TRANS_SESS_ID,
  TOGGLE_LOGIN_HAPPENING,
  RESET_LOGIN,
  UPDATE_PROFILE,
  UPDATE_EXPORT_CONTROL_BLOCK,
  UPDATE_ACCOUNTS_CSNS,
  UPDATE_BLOCKED_CSN,
  UPDATE_BLOCKED_ACCOUNT_NAME
} from './types';


export const updateUserData = (data) => {
  return {
    type: UPDATE_USER_DATA,
    payload: data,
  };
};

export const updateEteSignature = (data) => {
  return {
    type: UPDATE_ETE_SIGNATURE,
    payload: data,
  };
};

export const updateTransSessId = (data) => {
  return {
    type: UPDATE_TRANS_SESS_ID,
    payload: data,
  };
};

export const toggleLoginHappening = (val) => {
  return {
    type: TOGGLE_LOGIN_HAPPENING,
    payload: val,
  };
};

export const resetLoginState = () => {
  return {
    type: RESET_LOGIN,
  };
};
export const updateProfile = () => {
  return {
    type: UPDATE_PROFILE,
  };
};
export const updateExportControlBlock = (data) => {
  return {
    type: UPDATE_EXPORT_CONTROL_BLOCK,
    payload: data
  };
};
export const updateAccountCSNs = (data) => {
  return {
    type: UPDATE_ACCOUNTS_CSNS,
    payload: data
  };
};
export const updateBlockedCSN = (data) => {
  return {
    type: UPDATE_BLOCKED_CSN,
    payload: data
  };
};
export const updateBlockedAccountName = (data) => {
  return {
    type: UPDATE_BLOCKED_ACCOUNT_NAME,
    payload: data
  };
};

/**
 *   updateAccountCSNs,
  updateBlockedCSN,
  updateBlockedAccountName,
 */
